import {Button} from "../../../basic/button.tsx";
import {Trash2} from "lucide-react";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {VwpTeamMember} from "../../../../store/generated/api.ts";

interface MemberActionsProps {
    member: VwpTeamMember;
    onRemoveMember: (member: VwpTeamMember) => void;
    onManageLicenses: (member: VwpTeamMember) => void;
}

export function MemberActions({member, onRemoveMember, onManageLicenses}: MemberActionsProps) {
    const {t} = useTranslationWithKeys();
    return (
        <div className="flex gap-2">
            <Button
                size="sm"
                variant="outline"
                onClick={() => onManageLicenses(member)}
            >
                {t('common.action.manage')}
            </Button>
            <Button
                size="sm"
                variant="ghost"
                onClick={() => onRemoveMember(member)}
            >
                <Trash2 className="h-4 w-4"/>
            </Button>
        </div>
    );
}